import { render } from "./ShowStudentItem.vue?vue&type=template&id=61e8af52&scoped=true"
import script from "./ShowStudentItem.vue?vue&type=script&lang=js"
export * from "./ShowStudentItem.vue?vue&type=script&lang=js"

import "./ShowStudentItem.vue?vue&type=style&index=0&id=61e8af52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e8af52"]])

export default __exports__